/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_2_Paragraphs_1Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_2_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_2_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft’s alpha status and documented gaps make advanced workbook exchange something to test, not assume. Keeping Excel for a dependency-heavy workbook while trying GridCraft on a separate, simpler task is a practical way to learn what fits. A tool does not need to replace every spreadsheet in order to be useful.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_2_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_2_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 仍处于 Alpha 阶段，文档也记录了功能缺口，因此高级工作簿交换需要实际验证。可以保留 Excel 处理依赖复杂的文件，同时用 GridCraft 尝试独立的小任务，逐步了解适用范围。一个工具不必替代所有电子表格，仍然可以发挥作用。`)
};

/**
* | output |
* | --- |
* | "GridCraft’s alpha status and documented gaps make advanced workbook exchange something to test, not assume. Keeping Excel for a dependency-heavy workbook whi..." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_2_Paragraphs_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_2_paragraphs_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_2_Paragraphs_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_2_Paragraphs_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_2_paragraphs_1(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_2_paragraphs_1(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_2_paragraphs_1 as "gc.search_guides.gridcraft_vs_excel.sections.2.paragraphs.1" }